import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./css/master.css";
import "./css/custom.css";
import { BrowserRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename='/'>
        <App />
    </BrowserRouter>
);